import React from "react";
import {
  Box,
  Button,
  Typography,
  Grid,
  Card,
  CardContent,
  Avatar,
  Container,
  Divider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import EnquiryStats from "../components/enquiryStats";

const AdminDashboard = () => {
  const navigate = useNavigate();

  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : {};

  // Mock data for demonstration
  const adminName = user?.name;
  const branchName = user?.branch;
  const secondaryBranches = user?.secondaryBranches;

  const getAvatarInitials = (name) => {
    if (!name) return "";
    const words = name.trim().split(" ");
    return words.length === 1
      ? words[0][0].toUpperCase()
      : `${words[0][0]}${words[1][0]}`.toUpperCase();
  };

  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        py: 2,
      }}
    >
      {/* Admin Info */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          my: 2,
          padding: 2,
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: "#f5f5f5",
        }}
      >
        <Avatar sx={{ width: 56, height: 56, marginRight: 2 }}>
          {getAvatarInitials(adminName)}
        </Avatar>
        <Box>
          <Typography variant="h6">{adminName}</Typography>
          <Typography variant="body2" color="textSecondary">
            {secondaryBranches && secondaryBranches?.length > 0
              ? branchName + ", " + secondaryBranches.join(", ")
              : branchName}
          </Typography>
        </Box>
      </Box>

      <EnquiryStats />

      {/* Actions Section */}
      <Box
        sx={{
          my: 2,
          py: 2,
          backgroundColor: "#fff",
        }}
      >
        <Button
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: "#3B82F6",
            padding: "0.75rem",
            fontWeight: "bold",
            textTransform: "none",
            marginBottom: 1,
            fontSize: "1rem",
          }}
          onClick={() => navigate("/enquiry/table")} // Replace with actual route
        >
          View All Enquiries
        </Button>
      </Box>

      <Divider sx={{ my: 2 }} />
      {/* User Management Section */}
      {user?.role == "admin" && (
        <Box
          sx={{
            my: 2,
            py: 2,
            backgroundColor: "#f9f9f9",
            borderRadius: 2,
            boxShadow: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{ marginBottom: 2, textAlign: "center" }}
          >
            User Management
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Button
                variant="contained"
                fullWidth
                sx={{
                  backgroundColor: "#22C55E",
                  padding: "0.75rem",
                  fontWeight: "bold",
                  textTransform: "none",
                  fontSize: "1rem",
                }}
                onClick={() => navigate("/user/new")} // Replace with actual route
              >
                Add New User
              </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                variant="contained"
                fullWidth
                sx={{
                  backgroundColor: "#F59E0B",
                  padding: "0.75rem",
                  fontWeight: "bold",
                  textTransform: "none",
                  fontSize: "1rem",
                }}
                onClick={() => navigate("/users")} // Replace with actual route
              >
                Manage Users
              </Button>
            </Grid>
          </Grid>
        </Box>
      )}
    </Container>
  );
};

export default AdminDashboard;
